const delay = <T>(
  ms: number,
  data: T,
): Promise<T> => new Promise(resolve => { setTimeout(resolve, ms, data); });
export default delay;
